import { range } from 'aem-libs-ts/src/utils/number/range'

export const monthsRange = range(0, 11)

export const getYearsRange = (year: number) => range(year - 29, year + 50)

export const daysInWeek = range(1, 7)
